<template>
    <div>
        <vs-sidebar position-right parent="body" default-index="1" class="sidebarx" v-model="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--title-sidebar">
                        <h3>Settings OnBoarding</h3>
                    </section>
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            <div class="form-group">
                                <label>{{__("forms.Question.title")}}</label>
                                <input type="text" class="form-control" name="questionBase[name]" :value="name">
                            </div>
                            <div class="form-group">
                                <label>{{__("forms.Question.description")}}</label>
                                <input type="text" class="form-control" name="questionBase[description]" :value="description">
                            </div>
                            <div class="form-group">
                                <label>{{__("forms.Question.sorting")}}</label>
                                <input type="number" class="form-control" name="questionBase[sorting]" :value="sorting">
                            </div>

                            <div class="form-button clear" v-if="can_write">
                                <button class="btn btn--green" type="submit">Submit</button>
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
    export default {

        props: {
            can_write:{
                type:Boolean,
                required:true,
            }
        },
        data () {
            return {
                textQuestion : '',
                //default
                title: "OnBoarding",
                active : false,
                action : "",
                name:"",
                description:"",
                sorting:-1,
                editing : true,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        methods: {
            toggle(action, item_id, editing, attributes) {
                this.active     = true;
                this.action     = action;
                this.editing    = editing;

                let dataRoute   = decodeURI(attributes.dataRoute);
                if (dataRoute!==undefined) {
                    if (dataRoute.indexOf("[id]")>0) {
                        dataRoute = dataRoute.replace("[id]", item_id);

                    }
                    axios.get(dataRoute)
                        .then((response) => {
                            this.name = response.data.base.name;
                            this.description = response.data.base.description;
                            this.sorting = response.data.base.sorting;
                            this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);           

                        });
                }
            }

        }

    }
</script>

